import React from "react";
import { getVal, setVal } from "oolib";
import { TitleInputWithDefault } from "../../utils/TitleInputWithDefault";
import { ConfigForm_SectionWrapper } from "../../WidgetMetricCard/ConfigForm/ConfigForm_SectionWrapper";
import { WidgetHeader } from "../../WidgetBarChart/WIDGET_ELEM_ConfigForm";
import { BarChartConfigProvider, useBarChartConfig } from "../../WidgetBarChart/ConfigForm/ConfigForm_Context";
import { ConfigForm_FiltersSection } from "../../WidgetBarChart/ConfigForm/ConfigForm_FiltersSection";
import { DATA_KEYS } from "../../WidgetBarChart/ConfigForm/DATA_KEYS";
import { useWidgetFilterControls } from "../../utils/useWidgetFilterControls";
import { getWidgetHasDimensions } from "../../utils/getWidgetContentTypes";
import { HeatMapDataSection } from "./ConfigForm_DataSection";
import { SwitchRow } from "../../utils/CombineSegmentsControl";

const HeatMapDisplaySection = () => {
  const { widgetConfig, updateWidget } = useBarChartConfig();
  return (
    <ConfigForm_SectionWrapper icon="Eye" title="Display">
      <SwitchRow
        id="hideZeroValues"
        label="Hide Zero Values"
        value={!!getVal(widgetConfig, DATA_KEYS.hideZeroValues)}
        onChange={(next) => updateWidget(w => setVal(w, DATA_KEYS.hideZeroValues, next))}
      />
    </ConfigForm_SectionWrapper>
  );
};

export const HeatMapConfigForm = ({
  thisWidgetConfig,
  setConfig,
  underEditWidgetIdx,
  widgetIcon,
  widgetTitle,
  dimensionsInputPropsConfig = {},
}) => {
  const widgetType = thisWidgetConfig?.comp || 'WidgetHeatMapGrid';
  const hasDimensions = getWidgetHasDimensions(thisWidgetConfig, widgetType);
  const { filterHeaderProps, filterControlProps } = useWidgetFilterControls({
    hasDimensions
  });

  return (
    <BarChartConfigProvider
      thisWidgetConfig={thisWidgetConfig}
      setConfig={setConfig}
      underEditWidgetIdx={underEditWidgetIdx}
      showNumberInputsInOptions={true}
      showDimension2Input={true}
      dimensionsInputPropsConfig={dimensionsInputPropsConfig}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1.4rem' }}>
        <WidgetHeader title={widgetTitle} type="Chart" icon={widgetIcon} />

        <ConfigForm_SectionWrapper>
          <TitleInputWithDefault
            widgetConfig={thisWidgetConfig}
            widgetType="WidgetHeatMapGrid"
            setConfig={setConfig}
            underEditWidgetIdx={underEditWidgetIdx}
            titlePath={DATA_KEYS.field1}
            tagLabel="WIDGET TITLE"
            placeholder="Update custom label"
          />
        </ConfigForm_SectionWrapper>

        <ConfigForm_SectionWrapper icon="Database" title="Data">
          <HeatMapDataSection />
        </ConfigForm_SectionWrapper>

        <HeatMapDisplaySection />

        <ConfigForm_SectionWrapper
          icon="Funnel"
          title="Filters"
          {...filterHeaderProps}
        >
          <ConfigForm_FiltersSection {...filterControlProps} />
        </ConfigForm_SectionWrapper>
      </div>
    </BarChartConfigProvider>
  );
};
